var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 12H8.00065V14.6667H5.33398V12ZM5.33398 17.3333H8.00065V20H5.33398V17.3333ZM10.6673 12H13.334V14.6667H10.6673V12ZM10.6673 17.3333H13.334V20H10.6673V17.3333ZM16.0007 12H18.6673V14.6667H16.0007V12ZM16.0007 17.3333H18.6673V20H16.0007V17.3333Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 26.6667H21.3333C22.804 26.6667 24 25.4707 24 24V5.33333C24 3.86267 22.804 2.66667 21.3333 2.66667H18.6667V0H16V2.66667H8V0H5.33333V2.66667H2.66667C1.196 2.66667 0 3.86267 0 5.33333V24C0 25.4707 1.196 26.6667 2.66667 26.6667ZM21.3333 8L21.3347 24H2.66667V8H21.3333Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCalendar);
export default __webpack_public_path__ + "static/media/activeCalendar.0fb70e6a604169adb029218590adb412.svg";
export { ForwardRef as ReactComponent };